module.exports = __webpack_public_path__ + "static/media/output_1.adfc28da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WindRose/output_1.png
// module id = 2502
// module chunks = 0